import {
    BoostContentItemProps,
    BoostHistoryViewProps,
    BoostItemProps,
} from './types'
import {InformationCircleIcon} from '../Icon'
import React from 'react'
import {styled} from '../../stitches/config'
import {useTranslation} from 'react-i18next'

const StyledBoostHistory = styled('div', {padding: '$metadataPaddingVertical $metadataPaddingHorizontal'})

const StyledHeader = styled('div', {
    alignItems: 'center',
    display: 'flex',
    flexGrow: 1,
})

const StyledHeaderName = styled('div', {
    '& svg': {
        color: '$icon',
        height: '$metadataHeaderIcon',
        marginRight: '$metadataHeaderIconMargin',
    },
    'display': 'flex',
    'flexGrow': 1,
    'fontSize': '$metadataHeaderText',
    'fontWeight': '$metadataHeaderText',
})

const StyledContent = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '10px',
})

const StyledBoostItem = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '10px',
})

const StyledName = styled('span', {
    color: '$boostVisitorText',
    fontWeight: '600',
    marginRight: '10px',
    variants: {answer: {true: {color: '$boostAgentText'}}},
})

const StyledButton = styled('div', {
    border: '1px solid $boostButtonBorder',
    borderRadius: '4px',
    display: 'inline-flex',
    marginBottom: '4px',
    marginRight: '10px',
    padding: '3px 8px',
})

const StyledText = styled('div', {
    color: '$boostVisitorText',
    marginBottom: '4px',
    variants: {answer: {true: {color: '$boostAgentText'}}},
})

const getId = (s: string) => {
    let h = 0

    for (let i = 0; i < s.length; i += 1) {
        // eslint-disable-next-line no-bitwise
        h = Math.imul(31, h) + s.charCodeAt(i) | 0
    }

    return h
}

const BoostContentItem = (props: BoostContentItemProps): (React.ReactElement | null) => {
    const {item} = props

    return (
        <>
            <StyledText answer={true}>{item.content_text ? item.content_text : ''}</StyledText>
            {!!item.button_text &&
                <StyledButton>{item.button_text}</StyledButton>}
        </>
    )
}

const BoostItem = (props: BoostItemProps): (React.ReactElement | null) => {
    const {item} = props

    const {t} = useTranslation()

    const name = item.type === 'answer' ? t('Virtual agent') : t('Visitor')

    return (
        <StyledBoostItem>
            {item.type === 'button_clicked' &&
                <div><StyledName answer={false}>{t('{{user_name}} clicked', {user_name: name})}:</StyledName><StyledButton>{item.button_text ? `${item.button_text}` : 'Button'}</StyledButton></div>}
            {item.type !== 'button_clicked' &&
                <StyledName answer={item.type === 'answer'}>{name}:</StyledName>}
            {!!item.input_text && <span>{item.input_text}</span>}
            {item.content?.map((contentItem, i) => <div key={getId(i + JSON.stringify(contentItem))}><BoostContentItem item={contentItem} /></div>)}
        </StyledBoostItem>
    )
}

const BoostHistoryView = (props: BoostHistoryViewProps): React.ReactElement => {
    const {history} = props

    const {t} = useTranslation()

    return (
        <StyledBoostHistory>
            <StyledHeader>
                <StyledHeaderName>
                    <InformationCircleIcon />
                    {t('Boost history')}
                </StyledHeaderName>
            </StyledHeader>
            <StyledContent>
                {history.map((item, i) => <BoostItem item={item} key={getId(i + JSON.stringify(item))} />)}
            </StyledContent>
        </StyledBoostHistory>
    )
}

export default BoostHistoryView
